import { render } from "./AppTrapezoid.vue?vue&type=template&id=4f69ebc2&scoped=true&ts=true"
import script from "./AppTrapezoid.vue?vue&type=script&lang=ts"
export * from "./AppTrapezoid.vue?vue&type=script&lang=ts"

import "./AppTrapezoid.vue?vue&type=style&index=0&id=4f69ebc2&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f69ebc2"]])

export default __exports__